interface JsonApiErrorDocument {
  errors?: { title?: string; detail?: string }[];
}

/**
 * ll-api explains a rejected write in `errors[].detail`. Warp Drive puts the
 * parsed document on the thrown error's `content`, so without this the user
 * only ever sees "please try again" for a problem they could have fixed.
 */
export function requestErrorDetail(error: unknown): string | null {
  const candidate = error as {
    content?: JsonApiErrorDocument;
  } & JsonApiErrorDocument;
  const first = (candidate?.content?.errors ?? candidate?.errors)?.[0];
  const detail = first?.detail?.trim() || first?.title?.trim();

  return detail || null;
}

/** Appends what the API objected to, when it said anything useful. */
export function saveFailureMessage(error: unknown, fallback: string): string {
  const detail = requestErrorDetail(error);

  return detail ? `${fallback} ${detail}` : fallback;
}
